const BlogCard = {
  options: {
    data: {},
    customization: {},
    widgets: {
      Menu_ImageSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'imageSettings',
        },
        options: {
          image: {
            type: 'ImageUploader',
          },
          imageDirection: {
            order: 1,
            data: {
              direction: 'column',
              radioOptions: ['column', 'row'],
            },
            type: 'Radio',
          },
          imageBackgroundSize: {
            type: 'Radio',
            order: 7,
            data: {
              direction: 'row',
              radioOptions: ['stretch', 'cover', 'contain'],
            },
          },
        },
      },
      Menu_TitleSettings: {
        type: 'Menu',
        order: 200,
        renderOptions: {
          controlKey: 'titleSettings',
        },
        options: {
          titleText: {
            type: 'Text',
            order: 0,
          },
          titleTextColor: {
            type: 'HexColor',
            order: 1,
          },
          titleTextAlignment: {
            type: 'LeftCenterRight',
            order: 2,
          },
          titleTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          titleTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
          titleTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 1,
          },
          titleTextLetterSpacing: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 5,
          },
        },
      },
      Menu_DateSettings: {
        type: 'Menu',
        order: 300,
        renderOptions: {
          controlKey: 'dateSettings',
        },
        options: {
          dateText: {
            type: 'Text',
            order: 0,
          },
          dateTextColor: {
            type: 'HexColor',
            order: 1,
          },
          dateTextAlignment: {
            type: 'LeftCenterRight',
            order: 2,
          },
          dateTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          dateTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
          dateTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 1,
          },
          dateTextLetterSpacing: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 5,
          },
        },
      },
      Menu_DescriptionSettings: {
        type: 'Menu',
        order: 400,
        renderOptions: {
          controlKey: 'descriptionSettings',
        },
        options: {
          descriptionText: {
            type: 'Text',
            order: 0,
          },
          descriptionTextColor: {
            type: 'HexColor',
            order: 1,
          },
          descriptionTextAlignment: {
            type: 'LeftCenterRight',
            order: 2,
          },
          descriptionTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          descriptionTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
          descriptionTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 1,
          },
          descriptionTextLetterSpacing: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 5,
          },
        },
      },
      Menu_ButtonSettings: {
        type: 'Menu',
        order: 500,
        renderOptions: {
          controlKey: 'buttonSettings',
        },
        options: {
          buttonText: {
            type: 'Text',
            order: 0,
          },
          buttonTextColor: {
            type: 'HexColor',
            order: 1,
          },
          buttonTextAlignment: {
            type: 'LeftCenterRight',
            order: 2,
          },
          buttonTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          buttonTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
          buttonTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 1,
          },
          buttonTextLetterSpacing: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 5,
          },
        },
      },
      Menu_GeneralSettings: {
        type: 'Menu',
        order: 1300,
        renderOptions: {
          controlKey: 'OtherSettings',
        },
        options: {
          backgroundColor: {
            type: 'HexColor',
            order: 2,
          },
          borderRadius: {
            order: 3,
            data: {
              max: 40,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
          },
          borderColor: {
            type: 'HexColor',
            order: 4,
          },
          'widget.Tabs_1': {
            type: 'Tabs',
            order: 13,
            options: {
              padding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
            },
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'BlogCard_1',
      name: 'BlogCard_1',
      type: 'BlogCard',
      data: {},
      customization: {
        titleText: 'Kediler Depremi Hisseder mi?',
        titleTextAlignment: 'center',
        titleTextSize: '16px',
        titleTextColor: '#212121',
        titleTextStyle: 'normal',
        titleTextWeight: '500',
        titleTextLetterSpacing: '0px',

        dateText: '24 Nisan 2025 13:17',
        dateTextAlignment: 'center',
        dateTextSize: '10px',
        dateTextColor: '#0D74BB',
        dateTextStyle: 'normal',
        dateTextWeight: '400',
        dateTextLetterSpacing: '0px',
        descriptionText:
          'Kediler neden depremden önce tuhaf davranır? Doğal afetleri önceden sezebilen kediler hakkında bilmeniz gereken her şey. Kedinizin deprem öncesi davranışlarını tanıyın, hazırlıklı olun ve ona deprem anında nasıl yardım edeceğinizi öğrenin.',
        descriptionTextAlignment: 'center',
        descriptionTextSize: '13px',
        descriptionTextColor: '#212121',
        descriptionTextStyle: 'normal',
        descriptionTextWeight: '400',
        descriptionTextLetterSpacing: '0px',

        buttonText: 'Devamını Oku',
        buttonTextAlignment: 'center',
        buttonTextSize: '12px',
        buttonTextColor: '#737373',
        buttonTextStyle: 'normal',
        buttonTextWeight: '400',
        buttonTextLetterSpacing: '0px',

        backgroundColor: '#FFFFFF',
        padding: '15px 15px 15px 15px',
        borderRadius: '9px 9px 9px 9px',
        borderColor: '#E4E7EB',

        image: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png',
        imageDirection: 'column',
        imageBackgroundSize: 'stretch',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Timer+1.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
  ],
};

export default BlogCard;
